import { Routes, Route, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

//import components
import Header from "../components/static/Header";
import Footer from "../components/static/Footer";

//import tags
import { ToastContainer } from 'react-toastify';

// Import pages
import Home from "../pages/Home";
import About from "../pages/About";
import Products from "../pages/Products";
import ProductDetail from "../pages/ProductDetail";
import News from "../pages/News";
import NewsDetail from "../pages/NewsDetail";
import Faq from "../pages/Faq";
import Partners from "../pages/Partners";
import Cart from "../pages/Cart";
import Checkout from "../pages/Checkout";
import Success from "../pages/Success";
import Fail from "../pages/Fail";
import Contact from "../pages/Contact";
import Profile from "../pages/Profile";
import Orders from "../pages/Orders";
import Transactions from "../pages/Transactions";

import Personal from "../pages/Personal";
import Delivery from "../pages/Delivery";
import Return from "../pages/Return";
import Warranty from "../pages/Warranty";
import Cookie from "../pages/Cookie";


import NotFound from "../pages/NotFound";

function Web() {
  const { locale } = useParams(); // Get the locale from the URL params
  const { i18n } = useTranslation();

  // If locale changes, update the language in i18n
  useEffect(() => {
    if (locale && i18n.language !== locale) {
      i18n.changeLanguage(locale);
    }
  }, [locale, i18n]);

  return (
    <>
      <Header locale={locale} /> {/* Pass locale to Header */}
      <div className="content">
        <Routes>
          {/* Use the current locale from useParams */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products/:slug" element={<Products />} />
          <Route path="/product/:slug" element={<ProductDetail />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:slug" element={<NewsDetail />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/success" element={<Success />} />
          <Route path="/fail" element={<Fail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/transactions" element={<Transactions />} />
          <Route path="/personal" element={<Personal />} />
          <Route path="/delivery" element={<Delivery />} />
          <Route path="/return" element={<Return />} />
          <Route path="/warranty" element={<Warranty />} />
          <Route path="/cookie" element={<Cookie />} />


          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <Footer locale={locale} /> {/* Pass locale to Footer */}
      <ToastContainer position="top-right" autoClose={5000} />
    </>
  );
}

export default Web;
